import { Modal } from '@cmhc-schl/hearth-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const DeleteArrearsModal = ({
  isActive,
  onClose,
  onConfirm,
  loading
}: {
  isActive: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');
  return (
    <Modal
      id="delete-arrears-modal"
      isActive={isActive}
      title={{ value: t('arrearsTable.deleteSection.confirmDeleteModal.header') }}
      bodyContent={t('arrearsTable.deleteSection.confirmDeleteModal.content')}
      onDismissalCallback={() => {
        onClose();
      }}
      modalButtons={{
        secondaryButton: {
          name: 'secondary',
          text: { value: t('arrearsTable.deleteSection.confirmDeleteModal.cancel') },
          ariaText: { value: t('arrearsTable.deleteSection.confirmDeleteModal.cancel') },
          onClick: onClose
        },
        primaryButton: {
          name: 'primary',
          text: { value: t('arrearsTable.deleteSection.confirmDeleteModal.confirm') },
          ariaText: { value: t('arrearsTable.deleteSection.confirmDeleteModal.confirm') },
          onClick: onConfirm,
          loading: loading
        }
      }}
    />
  );
};
